/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import OrientationEnum from '../../orientation/orientation-enum';

/**
 * Komunikátor orientací obrazovky pro Ki-Wi Server.
 */
class CommunicatorOrientation {
  /**
   * Vygeneruje orientaci obrazovky.
   * @param {OrientationEnum} [value] Orientace obrazovky.
   * @returns {null|number} Orientace obrazovky ve formátu pro server.
   */
  static generate(value) {
    let result;
    switch (value) {
      case OrientationEnum.CLOCKWISE_0:
        result = 0;
        break;
      case OrientationEnum.CLOCKWISE_90:
        result = 90;
        break;
      case OrientationEnum.CLOCKWISE_180:
        result = 180;
        break;
      case OrientationEnum.CLOCKWISE_270:
        result = 270;
        break;
      default:
        result = null;
    }
    return result;
  }

  /**
   * Zpracuje orientaci obrazovky.
   * @param {number} [value] Nastavení orientace ve formátu, který vrací server.
   * @returns {OrientationEnum|null} Orientace obrazovky.
   */
  static parse(value) {
    let result;
    switch (value) {
      case 0:
        result = OrientationEnum.CLOCKWISE_0;
        break;
      case 90:
        result = OrientationEnum.CLOCKWISE_90;
        break;
      case 180:
        result = OrientationEnum.CLOCKWISE_180;
        break;
      case 270:
        result = OrientationEnum.CLOCKWISE_270;
        break;
      default:
        result = null;
    }
    return result;
  }
}

export default CommunicatorOrientation;
